import QuinekLogo from '../Images/logo_1024.png';

const Splash = () => {
    return (
        <div>
            <img style={{width: '80%'}} className='d-flex m-auto' src={QuinekLogo} alt='Loading...'/>
        </div>
    );
}

export default Splash;